import React, { useContext } from 'react';
import { SaveAsPatchContext, ISaveAsPatchContext } from '../../saveAsPatchModalState/saveAsPatchModalContext';
import { TypeOfChanges } from './components/TypeOfChanges';
import { Info } from './components/Info';
import { RestaurantsMultipleSelect } from './components/RestaurantsMultipleSelect';
import { PropertiesMultipleSelect } from './components/PropertiesMultipleSelect';
import { Cron } from './components/Cron';
import { BtnBlock } from './components/BtnBlock';
import style from './Forms.module.scss';

export const Forms: React.FC = () => {
	const {
		saveData,
		setTypeOfChanges,
		setIDsRestaurant,
		setProperties,
		changePrice,
		changeSupplementPrice,
		changeQuantityMaxLimit,
		changeActivationSchedule,
		changeDeactivationSchedule,
		toggleInStop,
		toggleIsRestricted,
		toggleIsPreselected,
		toggleForceDisable,
		changeTypeOfModalWindow,
		initialFormData,
		typeOfChanges,
		IDsSelectedRestaurant,
		selectedProperties,
		price,
		supplementPrice,
		quantityMaxLimit,
		activationSchedule,
		deactivationSchedule,
		inStop,
		isRestricted,
		isPreselected,
		forceDisable,
	} = useContext<ISaveAsPatchContext>(SaveAsPatchContext);

	return (
		<div className={style.container} data-test="CreateStudioModal">
			<TypeOfChanges setTypeOfChanges={setTypeOfChanges} typeOfChanges={typeOfChanges} />
			{typeOfChanges === 'basedChanges' && (
				<Info
					customerName={initialFormData.customerName}
					fetchedRestaurants={initialFormData.fetchedRestaurants}
					IDSelectedRestaurantOnRestPropsPage={initialFormData.IDSelectedRestaurantOnRestPropsPage}
					price={initialFormData.price}
					supplementPrice={initialFormData.supplementPrice}
					quantityMaxLimit={initialFormData.quantityMaxLimit}
					activationSchedule={initialFormData.activationSchedule}
					deactivationSchedule={initialFormData.deactivationSchedule}
					inStop={initialFormData.inStop}
					isRestricted={initialFormData.isRestricted}
					isPreselected={initialFormData.isPreselected}
					forceDisable={initialFormData.forceDisable}
					hasPortions={initialFormData.hasPortions}
				/>
			)}
			<RestaurantsMultipleSelect
				setIDsRestaurant={setIDsRestaurant}
				restaurants={initialFormData.fetchedRestaurants}
				IDSelectedRestaurantOnRestPropsPage={initialFormData.IDSelectedRestaurantOnRestPropsPage}
				IDsSelectedRestaurant={IDsSelectedRestaurant}
				typeOfChanges={typeOfChanges}
			/>
			<PropertiesMultipleSelect
				setProperties={setProperties}
				selectedProperties={selectedProperties}
				isCreatedFromPos={initialFormData.isCreatedFromPos}
				hasPortions={initialFormData.hasPortions}
			/>
			{typeOfChanges === 'independentChanges' && !!selectedProperties.length && (
				<Cron
					selectedProperties={selectedProperties}
					changePrice={changePrice}
					changeSupplementPrice={changeSupplementPrice}
					changeQuantityMaxLimit={changeQuantityMaxLimit}
					changeActivationSchedule={changeActivationSchedule}
					changeDeactivationSchedule={changeDeactivationSchedule}
					toggleInStop={toggleInStop}
					toggleIsRestricted={toggleIsRestricted}
					toggleIsPreselected={toggleIsPreselected}
					toggleForceDisable={toggleForceDisable}
					hasSchedulePriority={initialFormData.hasSchedulePriority}
					price={price}
					supplementPrice={supplementPrice}
					quantityMaxLimit={quantityMaxLimit}
					activationSchedule={activationSchedule}
					deactivationSchedule={deactivationSchedule}
					inStop={inStop}
					isRestricted={isRestricted}
					isPreselected={isPreselected}
					forceDisable={forceDisable}
				/>
			)}
			<BtnBlock
				onClose={() => changeTypeOfModalWindow('toConfirmFieldsClearing')}
				onSaveAndMakeOtherChanges={() => saveData('saveAndMakeOtherChanges')}
				onSaveAndClose={() => saveData('saveAndClose')}
				disabledSave={!IDsSelectedRestaurant.length || !selectedProperties.length}
			/>
		</div>
	);
};
